import AGREGAR_CATALOGO_COLONIA from '@/graphql/mutations/administracion/catalogos/colonias/agregarCatalogoColonia.gql';
import ACTUALIZAR_CATALOGO_COLONIA from '@/graphql/mutations/administracion/catalogos/colonias/actualizarCatalogoColonia.gql';
import OBTENER_CATALOGO_COLONIAS from '@/graphql/querys/administracion/catalogos/colonias/catalogoColonias.gql';
import ELIMINAR_CATALOGO_COLONIA from '@/graphql/mutations/administracion/catalogos/colonias/removerCatalogoColonia.gql';

export default {
  apollo: {
    catalogoColonias: {
      query: OBTENER_CATALOGO_COLONIAS,
    },
  },
  methods: {
    async mixAgregarCatalogoColonia() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_COLONIA,
        variables: {
          colonia: this.catalogoColonia,
        },
        update: (store, { data: { agregarCatalogoColonia } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_COLONIAS });
          data.catalogoColonias.push(agregarCatalogoColonia);
          store.writeQuery({ query: OBTENER_CATALOGO_COLONIAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoColonia() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_COLONIA,
        variables: {
          id: this.catalogoColoniaEditar.id,
          colonia: this.catalogoColonia,
        },
        update: (store, { data: { actualizarCatalogoColonia } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_COLONIAS });
          const { catalogoColonias } = data;
          const index = catalogoColonias
            .findIndex(
              (catalogoColonia) => catalogoColonia.id === actualizarCatalogoColonia.id,
            );
          if (index !== -1) {
            catalogoColonias.splice(index, 1, actualizarCatalogoColonia);
          }
          store.writeQuery({ query: OBTENER_CATALOGO_COLONIAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixEliminarCatalogoColonia(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ELIMINAR_CATALOGO_COLONIA,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_COLONIAS });
          data.catalogoColonias = data.catalogoColonias.filter(
            (catalogoColonia) => catalogoColonia.id !== id,
          );
          store.writeQuery({ query: OBTENER_CATALOGO_COLONIAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
  },
};
